import { useAfterLoginByOauthPathStorage } from "@/modules/auth/shared/utils/use-after-login-by-oauth-path-storage";
import { Navigate } from "react-router-dom";

export function RestoreRoute() {
  const { path } = useAfterLoginByOauthPathStorage();

  return <Navigate to={path} replace />;
}
